<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ix"></a>
<h2 class="fmtitle"><span class="bold">Abbreviations</span></h2>
<p class="abb"><span class="abb_hang"><em class="italic">BAR</em></span> <em class="italic">Biblical Archaeology Review</em></p>
<p class="abb"><span class="abb_hang"><em class="italic">BASOR</em></span> <em class="italic">Bulletin of the American Schools of Oriental Research</em></p>
<p class="abb"><span class="abb_hang"><em class="italic">DOP</em></span> <em class="italic">Dumbarton Oaks Papers</em></p>
<p class="abb"><span class="abb_hang"><em class="italic">ERH</em></span> <em class="italic">English Historical Review</em></p>
<p class="abb"><span class="abb_hang"><em class="italic">Eu. Jud.</em></span> <em class="italic">European Judaism: A Journal for the New Europe</em></p>
<p class="abb"><span class="abb_hang"><em class="italic">HTR</em></span> <em class="italic">The Harvard Theological Review</em></p>
<p class="abb"><span class="abb_hang"><em class="italic">IEJ</em></span> <em class="italic">Israel Exploration Journal</em></p>
<p class="abb"><span class="abb_hang"><em class="italic">JQR</em></span> <em class="italic">Jewish Quarterly Review</em></p>
<p class="abb"><span class="abb_hang"><em class="italic">JRS</em></span> <em class="italic">Journal of Roman Studies</em></p>
<p class="abb"><span class="abb_hang"><em class="italic">NAPNF 2</em></span> <em class="italic">The Nicene and Post-Nicene Fathers of the Church</em>, Series 2</p>
<p class="abb"><span class="abb_hang"><em class="italic">NEAEHL</em></span> <em class="italic">The New Encyclopedia of Archaeological Excavations in the Holy Land</em>, Ephraim Stern (ed.), 1993–2008, Jerusalem</p>
<p class="abb"><span class="abb_hang">NEArch</span> <em class="italic">Near Eastern Archaeology</em></p>
<p class="abb"><span class="abb_hang"><em class="italic">PEQ</em></span> <em class="italic">Palestine Exploration Quarterly</em></p>
<p class="abb"><span class="abb_hang"><em class="italic">SHA</em></span> <em class="italic">Scriptores Historiae Augustae</em> (see Primary Sources)</p>
<p class="abb"><span class="abb_hang"><em class="italic">SOAS</em></span> <em class="italic">Bulletin of the School of Oriental and African Studies</em></p>
<p class="abb"><span class="abb_hang"><em class="italic">WCJS</em></span> <em class="italic">A World Congress of Jewish Studies</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Abbreviations.vue?f15f3374